<template lang="pug">
  .onboarding-container
    v-tour(:name='feedOnboarding' :steps='steps' :options='customOptions' :callbacks='callbacks')
      template(slot-scope='tour')
        transition(name='fade')
          v-step(
            v-if='tour.currentStep === index'
            v-for='(step, index) of steps'
            :key='step.id'
            :step='step'
            :previous-step='tour.previousStep'
            :next-step='tour.nextStep'
            :stop='tour.stop'
            :is-first='tour.isFirst'
            :is-last='tour.isLast'
            :labels='tour.labels'
          )
            template
              .content(slot='content')
                .column
                  button.self-end(type='button' @click='tour.stop')
                    img(src='../../assets/ic_cross.svg')
                  p.description.text-normal.text-left(v-html='step.content')
                  img.image.self-center(:src='step.image')
            template
              .actions.column(slot='actions')
                .row.space-between
                  button(type='button' @click='tour.previousStep' :disabled='tour.isFirst')
                    simple-svg(
                      :filepath='backIcon'
                      :class='[ tour.isFirst ? "gray-icon" : "dark-gray-hover-blue" ]'
                      :alt='$t("onboarding.prev")'
                      :width='"24px"'
                      :height='"24px"'
                    )
                  .row.middle
                    .onboarding-pagination-dots(
                      v-for='stepNumber in steps.length'
                      :key='`onboarding-dots-${stepNumber}`'
                      :class='{ active: tour.currentStep === stepNumber - 1 }'
                    )
                  button(type='button' @click='tour.nextStep' :disabled='tour.isLast')
                    simple-svg(
                      :filepath='nextIcon'
                      :class='[ tour.isLast ? "gray-icon" : "dark-gray-hover-blue" ]'
                      :alt='$t("onboarding.next")'
                      :width='"24px"'
                      :height='"24px"'
                    )
                button.primary-button.white.finish.m4-top-5(v-if='tour.isLast' type='button' @click='tour.stop')
                  | {{ $t('onboarding.start') }}
</template>

<script>
import { mapActions } from 'vuex'

import backIcon from '../../assets/ic_chevron_circle_back.svg'
import nextIcon from '../../assets/ic_chevron_circle_next.svg'

import { feedOnboarding } from '../../utils/constants'
import { onboardingSteps } from '../../constants/onboarding'

export default {
  data() {
    return {
      backIcon,
      nextIcon,
      feedOnboarding,
      customOptions: {
        useKeyboardNavigation: true,
        startTimeout: 200
      },
      callbacks: {
        onStop: this.hideOverlay
      }
    }
  },
  computed: {
    steps() {
      return onboardingSteps()
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'setNavigationTutorialStatus'
    ]),
    async hideOverlay() {
      await this.setNavigationTutorialStatus(false)
      this.hideElement({ element: 'onboarding' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.onboarding-container {
  background: $gray-translusent;
  height: 100vh;
  width: 100vw;
  position: fixed;
  overflow: hidden;
  z-index: 6;
}

.content {
  padding: 16px 20px;
}

.actions {
  border-top: 1px solid $light-gray;
  padding: 16px;
}

.finish {
  --max-width: auto;
}

.image {
  height: 68px;
  margin-top: 28px;
  width: 172px;
}

.onboarding-pagination-dots {
  border: 1px solid $gray;
  border-radius: 100%;
  height: 8px;
  width: 8px;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &.active {
    background: $blue;
    border-color: $blue;
  }
}

.fade-enter-active {
  transition: opacity .5s;
}

.fade-leave-active {
  transition: opacity .3s;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}
</style>
